import { urlForImage } from './utils';

const DEFAULT_FALLBACK = '/n_images/default-blog.jpg';

/** Grid card thumbnail — ~400px wide, respects crop/hotspot. */
export function themeGridImageUrl(image: unknown): string {
  return urlForImage(image)?.width(400).fit('max').url() ?? DEFAULT_FALLBACK;
}

/** Lightbox full view — capped at 1600px. */
export function themeLightboxImageUrl(image: unknown): string {
  return urlForImage(image)?.width(1600).fit('max').url() ?? DEFAULT_FALLBACK;
}

/** JSON-LD / structured data thumbnail. */
export function themeThumbnailImageUrl(image: unknown): string | undefined {
  return urlForImage(image)?.width(400).fit('max').url();
}

/** Category hero banner — matches layout width (700px). */
export function themeBannerImageUrl(image: unknown): string {
  return urlForImage(image)?.width(700).fit('max').url() ?? DEFAULT_FALLBACK;
}

export function themeImageBlurDataUrl(
  image: unknown,
  fallback: string
): string {
  const img = image as { imgAsset?: { metadata?: { lqip?: string } } };
  return img?.imgAsset?.metadata?.lqip ?? fallback;
}
